import React from 'react';

interface SquareCheckIconProps {
  className?: string;
  size?: number;
}

const SquareCheckIcon: React.FC<SquareCheckIconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"/>
      <path d="m9 11 3 3L22 4"/>
    </svg>
  );
};

export default SquareCheckIcon;

